export const FILE_UPLOAD_LIMITS = {
	MAX_SIZE: 30 * 1024 * 1024, // 30MB
	ACCEPTED_TYPES: {
		"image/*": [".png", ".jpg", ".jpeg", ".webp"],
	},
	ACCEPTED_EXTENSIONS: [".png", ".jpg", ".jpeg", ".webp"],
} as const;

export const FILE_ERROR_MESSAGES = {
	FILE_TOO_LARGE: "File size must be less than 30MB",
	INVALID_FILE: "Please upload a valid image file (PNG, JPG, JPEG, or WEBP)",
	COMPRESSION_FAILED: "Image compression failed, using original file",
} as const;
